import { BuildRulesetQuery } from '../../../interfaces/Rulesets';
import { extractJsonFieldSql } from '../../extractJsonFieldSql';

export const selectFields_AM_PD_QCV: string = `
(delta * -1) + 3.0 as rank,
id,
label,
attributes
`;

export const order_AM_PD_QCV = 'rank DESC, label';

const getAttributes = (rawName: string) => ({
    'cvpos1': `$.6341.${rawName}`,
    'cvpos2': `$.6342.${rawName}`,
    'cvpos3-': `$.6349.${rawName}`,
    'cvpos3': `$.6343.${rawName}`,
    'cvpos4': `$.6344.${rawName}`,
    'cvpos4+': `$.6350.${rawName}`,
    'cvpos5': `$.6345.${rawName}`,
    'cvpos5+': `$.6351.${rawName}`,
    'cvpos6': `$.6346.${rawName}`,
    'cvposN': `$.6347.${rawName}`,
    'cvposNC': `$.6348.${rawName}`,
    cv: `$.148.${rawName}`,
    dpmax: `$.417.${rawName}`,
});

export const buildQuery_AM_PD_QCV: BuildRulesetQuery = ({
    selectFields,
    rawName,
    filter,
    volumetricFlow,
    kvs,
}): [string, string[]] => {

    const attrs = getAttributes(rawName);
    return [
        `WITH products_filtered as (SELECT ABS(cast(positions.value as float) - bounds.cv) as delta,
                                           cast(positions.value as float)                  as pos,
                                           positions.key                                   as posKey,
                                           cast(dpmaxAttr.value as float)                  as dpmax,
                                           cast(cvmaxAttr.value as float)                  as cvmax,
                                           product.id,
                                           label,
                                           attributes
                                    FROM product
                                             JOIN bounds
                                             CROSS JOIN json_each
                                       (json_array(

                                        ${extractJsonFieldSql('attributes', `${attrs['cvpos1']}[0]`)}
                                       , ${extractJsonFieldSql('attributes', `${attrs['cvpos2']}[0]`)}
                                       , ${extractJsonFieldSql('attributes', `${attrs['cvpos3-']}[0]`)}
                                       , ${extractJsonFieldSql('attributes', `${attrs['cvpos3']}[0]`)}
                                       , ${extractJsonFieldSql('attributes', `${attrs['cvpos4']}[0]`)}
                                       , ${extractJsonFieldSql('attributes', `${attrs['cvpos4+']}[0]`)}
                                       , ${extractJsonFieldSql('attributes', `${attrs['cvpos5']}[0]`)}
                                       , ${extractJsonFieldSql('attributes', `${attrs['cvpos5+']}[0]`)}
                                       , ${extractJsonFieldSql('attributes', `${attrs['cvpos6']}[0]`)}
                                       , ${extractJsonFieldSql('attributes', `${attrs['cvposN']}[0]`)}
                                       , ${extractJsonFieldSql('attributes', `${attrs['cvposNC']}[0]`)}
                                        )) as positions
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.dpmax}`)}) as dpmaxAttr
             LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.cv}`)}) as cvmaxAttr
         WHERE ${filter} AND pos is not null
         ORDER BY delta, pos
        DESC
            )
            , user_input as (SELECT cast(? as float) as v100, cast(? as float) as cv)
            , bounds as (SELECT
            cast(floor(cv * 0.89 * 10) as float) / 10 as lower,
            round(cv * 1.7, 1) as upper,
            v100,
            cv
            FROM user_input)
            , data as (SELECT
            first_value(pos) over (partition by label) as pos,
            first_value(delta) over (partition by label) as delta,
            dpmax,
            cvmax,
            id,
            label,
            attributes
            FROM products_filtered GROUP BY label ORDER BY delta ASC)
        SELECT ${selectFields}
        FROM data
                 JOIN bounds
        WHERE data.pos <= bounds.upper
          AND data.pos >= bounds.lower
          AND CASE
                  WHEN bounds.v100 > 0 AND dpmax > 0
                      THEN pow(bounds.v100 / data.cvmax, 2) <= dpmax
                  ELSE true END
        `,
        [volumetricFlow, kvs]
    ];
}



